import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";

const AddFaqs = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    // You can adjust the header configuration according to your API requirements
    faqModel
      .create(form)
      .then((response) => {
        // console.log(response.data, "fqAdd");
        helper.sweetalert.toast("Your Ads add.", "success");
        navigate("/admin/fAQs");
        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">AddFaqs</h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                    <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Select For</Label>
                          <Input id="forType" name="type" type="select">
                            <option value="driver">Select </option>
                            <option value="tutor">Tutor</option>
                            <option value="student">Student</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Question</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="question"
                            placeholder="Enter Question"
                          />
                        </FormGroup>
                      </Col>

                     
                    
                    </Row>

                    <Row>
                    <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Priority</Label>
                          <Input id="Priority" name="priority" type="number" />
                        </FormGroup>
                      </Col>
                   
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Answer</Label>
                          <Input
                            id="type"
                            name="answer"
                            type="textarea"
                            placeholder="Enter Answer"
                          />
                        </FormGroup>
                      </Col>

                    
                    </Row>

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/fAQs" tag={Link}>
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{ float: "right", marginLeft: "5%",backgroundColor:"#080278",color:"white",border:"none" }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddFaqs;
